import React from "react";

// Landing-page-only CTA button - its own component (rather than the shared
// <Button/> used across login/dashboard/wizard) purely for this page's
// bigger sizing/gradient treatment; the colors themselves come from the
// --land-* tokens, which now alias the app's own theme (see index.css).
const SIZES = {
  md: "px-7 py-3.5 text-[15px]",
  lg: "px-9 py-4 text-[17px]",
};

const GradientButton = ({ as: Tag = "button", variant = "primary", size = "lg", className = "", children, ...props }) => {
  const base = "inline-flex items-center justify-center gap-2 rounded-[12px] font-bold no-underline transition-all duration-300";
  const variants = {
    // Solid midnight fill rather than the .landing-aurora gradient: on the
    // editorial hero the CTA sits directly under an oversized headline, and a
    // flat dark block reads as a firmer call to action than a gradient
    // competing with the type. The aurora gradient stays on FeatureCard's top
    // rule, TimelineStep, and HeroMockup, where it still earns its place.
    primary:
      "bg-[var(--land-fill)] text-[var(--accent-ink)] shadow-[0_8px_24px_color-mix(in_srgb,var(--land-fill)_45%,transparent)] hover:bg-[var(--land-fill-hover)] hover:shadow-[0_12px_32px_color-mix(in_srgb,var(--land-fill)_60%,transparent)] hover:-translate-y-0.5",
    secondary:
      "border-[1.5px] border-[var(--land-primary)] text-[var(--land-primary)] bg-transparent hover:bg-[color-mix(in_srgb,var(--land-primary)_8%,transparent)]",
    white:
      "bg-white text-[var(--land-navy)] hover:bg-[#f0f4f8] hover:shadow-[0_4px_16px_rgba(0,0,0,0.15)]",
  };

  return (
    <Tag className={[base, variants[variant], SIZES[size], className].join(" ")} {...props}>
      {children}
    </Tag>
  );
};

export default GradientButton;
